/* @flow */

import { em } from 'polished';

export default {
  root: {
    width: em(18),
    height: em(14),
    fontSize: '1em',
  },
};
